import React from 'react';

import NoResultsIcon from 'icons/noresults-xl.svg';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import voca from 'voca';

import { useTabContext } from 'components/contexts/TabContext';

export default function BlankBookingSearchResult({ onBookingTabSelection }) {
  const { selectedTabKey, tabKeys } = useTabContext();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'bookings.BlankBookingSearchResult',
  });

  const [firstNonSelectedTabKey, secondNonSelectedTabKey] = tabKeys.filter(
    (tabKey) => selectedTabKey !== tabKey,
  );

  return (
    <div className='section section--notice tw-rounded-tl-none tw-rounded-tr-none tw-border-grey-100 tw-bg-white'>
      <NoResultsIcon
        className='[&_path]:tw-fill-grey-300'
        height={64}
        width={64}
      />
      <h2 className='section__header tw-text-l tw-font-semibold tw-text-grey-900'>
        {['upcomingBookings', 'pastBookings'].includes(selectedTabKey) ?
          i18nT('title.noBookingsFound')
        : i18nT('title.noEnrolmentsFound')}
      </h2>
      <p className='section__content tw-mb-2 tw-mt-8'>
        {secondNonSelectedTabKey ?
          <Trans
            components={{
              firstTabA: (
                /* eslint-disable jsx-a11y/anchor-has-content */
                <a
                  className='app-link tw-align-baseline tw-text-blue-500 hover:tw-text-blue-300 active:tw-text-blue-300'
                  href='#0'
                  onClick={() => onBookingTabSelection(firstNonSelectedTabKey)}
                />
                /* eslint-enable jsx-a11y/anchor-has-content */
              ),
              secondTabA: (
                /* eslint-disable jsx-a11y/anchor-has-content */
                <a
                  className='app-link tw-align-baseline tw-text-blue-500 hover:tw-text-blue-300 active:tw-text-blue-300'
                  href='#0'
                  onClick={() => onBookingTabSelection(secondNonSelectedTabKey)}
                />
                /* eslint-enable jsx-a11y/anchor-has-content */
              ),
            }}
            i18nKey={`bookings.BlankBookingSearchResult.description.${firstNonSelectedTabKey}And${voca.capitalize(secondNonSelectedTabKey)}`}
            ns='components'
          />
        : <Trans
            components={{
              a: (
                /* eslint-disable jsx-a11y/anchor-has-content */
                <a
                  className='app-link tw-align-baseline tw-text-blue-500 hover:tw-text-blue-300 active:tw-text-blue-300'
                  href='#0'
                  onClick={() => onBookingTabSelection(firstNonSelectedTabKey)}
                />
                /* eslint-enable jsx-a11y/anchor-has-content */
              ),
            }}
            i18nKey={`bookings.BlankBookingSearchResult.description.${firstNonSelectedTabKey}`}
            ns='components'
          />
        }
      </p>
    </div>
  );
}

BlankBookingSearchResult.propTypes = {
  onBookingTabSelection: PropTypes.func.isRequired,
};
